var Acr = Acr || {};

declare global {
    interface Window {
        Utility: any;
    }
}

var Utility = window.Utility || {};

import * as Constants from '../Constants';

export function AcrMLPNav() {

    let MLPNav: HTMLElement;
    let section: HTMLElement;
    let yearSelector: HTMLElement;
    let yearOptions: HTMLElement[];
    let button: HTMLElement;
    let buttonSVG: SVGElement[];
    let hamburger: HTMLElement;
    let translate: number = 0;
    let maxTranslate: number = 0;
    let swipeStartY: number;
    let swipeEndY: number;
    let debounce: ReturnType<typeof setTimeout>;

    const initSelectors = (el: HTMLElement) => {
        MLPNav = el;
        section = MLPNav.querySelector('section');
        yearSelector = MLPNav.querySelector('div[role=presentation]');
        yearOptions = [...yearSelector.querySelectorAll('a')];
        button = section.querySelector('button');
        buttonSVG = [...button.querySelectorAll('svg')];
        hamburger = MLPNav.querySelector('aside[role=menu]');
    };

    const _toggleHamburger = () => {

        Utility.slideToggle(hamburger,400, 'flex');

        _setMaxTranslate();

        if (hamburger.offsetWidth  > 0 && hamburger.offsetHeight > 0) {
            hamburger.style.display = 'flex';
        }

        // Flip flop the arrow icon
        buttonSVG.forEach(el => {
            el.classList.contains('hidden') ? el.classList.remove('hidden') : el.classList.add('hidden')
        });
    };

    function _expandYearSelector () {
        this.classList.contains('expanded') ? this.classList.remove('expanded') : this.classList.add('expanded')
    };

    function _selectYearOption () {

        let targetSiblings: HTMLElement [];

        this.classList.add('selected');
        targetSiblings = Utility.siblings(this, 'a');

        targetSiblings.forEach(element => {
            element.classList.remove('selected');
        });
    };

    const _attachTouch = () => {

        hamburger.removeEventListener('touchstart', _touchStartHandler);
        hamburger.addEventListener('touchstart', _touchStartHandler);

        hamburger.removeEventListener('touchmove', _touchMoveHandler);
        hamburger.addEventListener('touchmove', _touchMoveHandler);

        hamburger.removeEventListener('touchend', _touchEndHandler);
        hamburger.addEventListener('touchend', _touchEndHandler);
    };

    const _touchStartHandler = (e) => {
        swipeStartY = e.originalEvent.touches[0].clientY;

        translate = parseInt(hamburger.style.top, 10);

        hamburger.classList.remove('acr-animation');
    };


    const _touchMoveHandler = (e) => {
        let dY;

        let top;

        swipeEndY = e.originalEvent.touches[0].clientY;

        dY = swipeStartY - swipeEndY;

        dY *= -1;

        top = translate + dY;

        if (top > 0) {
            top = 0;
        } else if (top * -1 > maxTranslate) {
            top = maxTranslate * -1;
        }

        hamburger.style.top = top.toString() + 'px';

        hamburger.classList.add('acr-animation');
    };

    const _touchEndHandler = () => {
        swipeStartY = null;

        swipeEndY = null;
    };

    const _setMaxTranslate = () => {
        let menuBarHeight = section.clientHeight;

        let viewPortHeight = window.innerHeight;

        let hamburgerViewPortH = viewPortHeight - menuBarHeight;

        maxTranslate = Math.abs(hamburger.clientHeight - hamburgerViewPortH);
    };

    const _attachResize = () => {
        clearTimeout(debounce);

        debounce = setTimeout(_onResize, 250);
    };

    const _onResize = () => {
        if (window.innerWidth < Constants.breakpoints.lg
            && yearSelector.classList.contains('expanded')) {

            yearSelector.classList.remove('expanded');
        }
    };


    const init = (element) => {

        initSelectors(element);

        // Set Overview button up arrow to hidden on mobile
        buttonSVG[1].classList.add('acr-icon');
        buttonSVG[1].classList.add('hidden');

        if ((MLPNav.querySelector('.acr-header > div') as HTMLElement)) {
            (MLPNav.querySelector('.acr-header > div') as HTMLElement).style.position = 'relative';
        }
        

        button.addEventListener('click', _toggleHamburger);
        yearSelector.addEventListener('click', _expandYearSelector);
        yearOptions.forEach(e =>{
            e.addEventListener('click', _selectYearOption)
        });
        window.addEventListener('resize', _attachResize);

        _attachTouch();
    }

    return {
        init: init,
    };


};